import { render, staticRenderFns } from "./SGPAssociarComponent.vue?vue&type=template&id=40eff2ef&scoped=true"
import script from "./SGPAssociarComponent.vue?vue&type=script&lang=js"
export * from "./SGPAssociarComponent.vue?vue&type=script&lang=js"
import style0 from "./SGPAssociarComponent.vue?vue&type=style&index=0&id=40eff2ef&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40eff2ef",
  null
  
)

export default component.exports